module.exports = __webpack_public_path__ + "static/home4-e8b7da66bb3bc930a35b3a347d121919.jpg";